import React from "react";
import carousel1 from "../../assets/img/carousel1.webp"
import carousel2 from "../../assets/img/carousel2.webp"
import carousel3 from "../../assets/img/carousel3.webp"
import testimonial1 from "../../assets/img/testimonial-1.jpg"
import testimonial2 from "../../assets/img/testimonial-2.jpg"
import testimonial3 from "../../assets/img/testimonial-3.jpg"
import testimonial4 from "../../assets/img/testimonial-4.jpg"
import testimonial5 from "../../assets/img/testimonial-5.jpg"
import testimonial6 from "../../assets/img/testimonial-6.jpg"
import testimonial7 from "../../assets/img/testimonial-7.jpg"
import testimonial8 from "../../assets/img/testimonial-8.jpg"
import testimonial9 from "../../assets/img/testimonial-9.jpg"
import testimonial10 from "../../assets/img/testimonial-10.jpg"
import testimonial11 from "../../assets/img/testimonial-11.jpg"
import testimonial12 from "../../assets/img/testimonial-12.jpg"
import { Link } from "react-router-dom";

const Home = () => {

    return(
        <>
    <div className="container-fluid p-0 wow fadeIn" data-wow-delay="0.1s">
        <div id="header-carousel" className="carousel slide" data-bs-ride="carousel">
            <div className="carousel-indicators">
                <button type="button" data-bs-target="#header-carousel" data-bs-slide-to="0" className="active"
                    aria-current="true" aria-label="Slide 1">
                    <img className="img-fluid" src={carousel1} alt="Image" /> 
                </button>
                <button type="button" data-bs-target="#header-carousel" data-bs-slide-to="1" aria-label="Slide 2">
                    <img className="img-fluid" src={carousel2} alt="Image" />
                </button>
                <button type="button" data-bs-target="#header-carousel" data-bs-slide-to="2" aria-label="Slide 3">
                    <img className="img-fluid" src={carousel3} alt="Image" />
                </button>
            </div>
            <div className="carousel-inner">
                <div className="carousel-item active">
                    <img className="w-100" src={carousel1} style={{height:"740px", objectFit:"cover"}} alt="Image" />
                    <div className="carousel-caption">
                        <h1 className="text-uppercase text-white mb-4 animated zoomIn">The life of the law has not been logic. it has been experience
                        </h1>
                        <span style={{cursor: "default"}} href="#" className="btn btn-primary py-3 px-4">— Oliver Wendell Holmes Jr.</span>
                    </div>
                </div>
                <div className="carousel-item">
                    <img className="w-100" src={carousel2} style={{height:"740px", objectFit:"cover"}}  alt="Image" />
                    <div className="carousel-caption">
                        <h1 className="text-uppercase text-white mb-4 animated zoomIn">A lawyer's time and advice are his stock in trade.
                        </h1>
                        <span style={{cursor: "default"}} href="#" className="btn btn-primary py-3 px-4">— Abraham Lincoln</span>
                    </div>
                </div>
                <div className="carousel-item">
                    <img className="w-100" src={carousel3} style={{height:"740px", objectFit:"cover"}} alt="Image" />
                    <div className="carousel-caption">
                        <h1 className="text-uppercase text-white mb-4 animated zoomIn">The law is reason, free from passion.
                        </h1>
                        <span style={{cursor: "default"}} href="#" className="btn btn-primary py-3 px-4">— Aristotle</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div className="container-fluid pt-6 pb-3">
        <div className="container">
            <div className="row g-5">
                <h1 style={{color: "#bb790f"}}>ABOUT SMN</h1>
                <div className="col-lg-12 wow fadeIn mt-0" data-wow-delay="0.5s">
                    <h3 className=" text-uppercase mb-4">Experienced lawyers delivering practical legal solutions</h3>
                    <p className="mb-4">Sahibzada, Mujtaba & Naqvi (SMN) is in the initial stage of becoming one of the largest
                    and most well reputed law firms in Pakistan highly regarded for its expertise in both
                    contentious and non-contentious matters. The firm has 3 Partners and 4 Associates
                    operating from the firm's offices in Lahore, Okara and Islamabad.</p>
                    <div className="row g-5 mb-4">
                        <div className="col-sm-6">
                            <div className="d-flex align-items-center">
                                <div className="flex-shrink-0 btn-xl-square bg-light me-3">
                                    <i className="fa fa-users-cog fa-2x text-primary"></i>
                                </div>
                                <h5 className="lh-base text-uppercase mb-0">Certified Expert & Team</h5>
                            </div>
                        </div>
                        <div className="col-sm-6">
                            <div className="d-flex align-items-center">
                                <div className="flex-shrink-0 btn-xl-square bg-light me-3">
                                    <i className="fa fa-hourglass-start fa-2x text-primary"></i>
                                </div>
                                <h5 className="lh-base text-uppercase mb-0">Smart & Legal Solutions</h5>
                            </div>
                        </div>
                    </div>
                    <p><i className="fa fa-check-square text-primary me-3"></i>Certified experts with proven legal skills
                    </p>
                    <p><i className="fa fa-check-square text-primary me-3"></i>Trusted team with strong case history
                    </p>
                    <p><i className="fa fa-check-square text-primary me-3"></i>Focused on results with full integrity
                    </p>
                    <div className="border border-5 border-primary p-4 text-center mt-4">
                        <h4 className="lh-base text-uppercase mb-0">We’re Skilled in All Legal Matters Using Trusted Law Practices</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div className="container-fluid feature mt-6 wow fadeIn" data-wow-delay="0.1s">
        <div className="container">
            <div className="row g-0 justify-content-end">
                <div className="col-lg-6 pt-5">
                    <div className="mt-5">
                        <h1 className="display-6 text-white text-uppercase mb-4 wow fadeIn" data-wow-delay="0.3s">Why You should Choose Our legal Services</h1>
                        <p className="text-light mb-4 wow fadeIn" data-wow-delay="0.4s">Choosing our legal services means working with a dedicated team that understands your needs. We provide smart legal solutions, clear communication, and full support in every step of your case. Whether it's personal or business-related, we ensure you’re guided with care and confidence.</p>
                        <div className="row g-4 pt-2 mb-4">
                            <div className="col-sm-6 wow fadeIn" data-wow-delay="0.4s">
                                <div className="flex-column text-center border border-5 border-primary p-5">
                                    <h1 className="text-white" data-toggle="counter-up">100+</h1>
                                    <p className="text-white text-uppercase mb-0">Corporate <br /> Clients</p>
                                </div>
                            </div>
                            <div className="col-sm-6 wow fadeIn" data-wow-delay="0.5s">
                                <div className="flex-column text-center border border-5 border-primary p-5">
                                    <h1 className="text-white" data-toggle="counter-up">9999</h1>
                                    <p className="text-white text-uppercase mb-0">Complete Projects</p>
                                </div>
                            </div>
                        </div>
                        <div className="border border-5 border-primary border-bottom-0 p-5">
                            <div className="experience mb-4 wow fadeIn" data-wow-delay="0.6s">
                                <div className="d-flex justify-content-between mb-2">
                                    <span className="text-white text-uppercase">Experience</span>
                                    <span className="text-white">90%</span>
                                </div>
                                <div className="progress">
                                    <div className="progress-bar bg-primary" role="progressbar" aria-valuenow="90"
                                        aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                            <div className="experience wow fadeIn" data-wow-delay="0.7s">
                                <div className="d-flex justify-content-between mb-2">
                                    <span className="text-white text-uppercase">Work Done</span>
                                    <span className="text-white">95%</span>
                                </div>
                                <div className="progress">
                                    <div className="progress-bar bg-primary" role="progressbar" aria-valuenow="95"
                                        aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div className="container-fluid service pt-6 pb-6">
        <div className="container">
            <div className="text-center mx-auto wow fadeInUp" data-wow-delay="0.1s" style={{maxWidth: "600px"}}>
                <h1 style={{color: "#bb790f"}} className="display-6 text-uppercase mb-2">Expertise</h1>
            </div>
            <div className="row g-4">
                <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="service-item">
                        <div className="service-inner p-5 d-flex align-items-center">
                            <div className="service-text">
                                <h5 className="text-uppercase text-center">Corporate Services</h5>
                            <Link className="btn btn-light px-3" to="/expertise#corporate">Read More<i
                                    className="bi bi-chevron-double-right ms-1"></i>
                            </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="service-item">
                        <div className="service-inner p-5 d-flex align-items-center">
                            <div className="service-text">
                                <h5 className="text-uppercase text-center">Tax <br /> Matters</h5>
                            <Link className="btn btn-light px-3" to="/expertise#tax">Read More<i
                                    className="bi bi-chevron-double-right ms-1"></i>
                            </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="service-item">
                        <div className="service-inner p-5 d-flex align-items-center">
                            <div className="service-text">
                                <h5 className="text-uppercase text-center">Financial Services</h5>
                            <Link className="btn btn-light px-3" to="/expertise#financial">Read More<i
                                    className="bi bi-chevron-double-right ms-1"></i>
                            </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="service-item">
                        <div className="service-inner p-5 d-flex align-items-center">
                            <div className="service-text">
                                <h5 className="text-uppercase text-center">Property Services</h5>
                            <Link className="btn btn-light px-3" to="/expertise#property">Read More<i
                                    className="bi bi-chevron-double-right ms-1"></i>
                            </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="service-item">
                        <div className="service-inner p-5 d-flex align-items-center">
                            <div className="service-text">
                                <h5 className="text-uppercase text-center">Banking & Finance</h5>
                            <Link className="btn btn-light px-3" to="/expertise#banking">Read More<i
                                    className="bi bi-chevron-double-right ms-1"></i>
                            </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="service-item">
                        <div className="service-inner p-5 d-flex align-items-center">
                            <div className="service-text">
                                <h5 className="text-uppercase text-center">Water & Power Matters</h5>
                            <Link className="btn btn-light px-3" to="/expertise#water">Read More<i
                                    className="bi bi-chevron-double-right ms-1"></i>
                            </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="service-item">
                        <div className="service-inner p-5 d-flex align-items-center">
                            <div className="service-text">
                                <h5 className="text-uppercase text-center">Real Estate Development</h5>
                            <Link className="btn btn-light px-3" to="/expertise#realestate">Read More<i
                                    className="bi bi-chevron-double-right ms-1"></i>
                            </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                    <div className="service-item">
                        <div className="service-inner p-5 d-flex align-items-center">
                            <div className="service-text">
                                <h5 className="text-uppercase text-center">Dispute Resolution</h5>
                            <Link className="btn btn-light px-3" to="/expertise#dispute">Read More<i
                                    className="bi bi-chevron-double-right ms-1"></i>
                            </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div className="container-fluid appoinment mb-6 py-5 wow fadeIn" data-wow-delay="0.1s">
        <div className="container pt-5">
            <div className="row gy-5 gx-0">
                <div className="col-lg-6 pe-lg-5 wow fadeIn" data-wow-delay="0.3s">
                    <h2 className=" text-uppercase text-white mb-4">We’re Always Ready to Discuss Your Legal Case
                    </h2>
                    <p className="text-white mb-5 wow fadeIn" data-wow-delay="0.4s">We offer easy and flexible legal appointments designed to fit your busy schedule, ensuring you get the support you need on time.</p>
                    <div className="d-flex align-items-start wow fadeIn" data-wow-delay="0.5s">
                        <div className="btn-lg-square bg-white">
                            <i className="bi bi-geo-alt text-dark fs-3"></i>
                        </div>
                        <div className="ms-3">
                            <h6 className="text-white text-uppercase">Office Address</h6>
                            <span className="text-white">11-A, Birdwood Link Lawrence Road, Lahore</span>
                        </div>
                    </div>
                    <hr className="bg-body" />
                    <div className="d-flex align-items-start wow fadeIn" data-wow-delay="0.6s">
                        <div className="btn-lg-square bg-white">
                            <i className="bi bi-clock text-dark fs-3"></i>
                        </div>
                        <div className="ms-3">
                            <h6 className="text-white text-uppercase">Office Time</h6>
                            <span className="text-white">Mon-Fri 09am-6pm, Sat, Sun Closed</span>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 mb-n5 wow fadeIn" data-wow-delay="0.7s">
                    <div className="bg-white p-5">
                        <h2 className="text-uppercase mb-4">Online Appoinment</h2>
                        <div className="row g-3">
                            <div className="col-sm-6">
                                <div className="form-floating">
                                    <input type="text" className="form-control border-0 bg-light" id="name" placeholder="Your Name" />
                                    <label for="name">Your Name</label>
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="form-floating">
                                    <input type="email" className="form-control border-0 bg-light" id="mail" placeholder="Your Email" />
                                    <label for="mail">Your Email</label>
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="form-floating">
                                    <input type="text" className="form-control border-0 bg-light" id="mobile" placeholder="Your Mobile" />
                                    <label for="mobile">Your Mobile</label>
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="form-floating">
                                    <select className="form-select border-0 bg-light" id="service">
                                        <option selected>Case Type</option>
                                        <option value="">Tax Matters</option>
                                        <option value="">Financial Services</option>
                                        <option value="">Corporate Services</option>
                                        <option value="">Intellectual Property Services</option>
                                        <option value="">Banking and Finance</option>
                                        <option value="">Commercial</option>
                                        <option value="">Water & Power</option>
                                        <option value="">Real Estate Development and Construction</option>
                                        <option value="">Dispute Resolution</option>

                                    </select>
                                    <label for="service">Choose A Service</label>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-floating">
                                    <textarea className="form-control border-0 bg-light" placeholder="Leave a message here" id="message"
                                        style={{height: "130px"}}></textarea>
                                    <label for="message">Message</label>
                                </div>
                            </div>
                            <div className="col-12 text-center">
                                <button className="btn btn-primary w-100 py-3" type="submit">Submit Now</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div className="container-fluid team pt-3 pb-3">
        <div className="container">
            <div className="text-center mx-auto wow fadeInUp" data-wow-delay="0.1s" style={{maxWidth: "600px"}}>
                <h1 style={{color: "#bb790f"}} className="display-6 text-uppercase mb-5">Meet Our Professional and Experience Lawyers</h1>
            </div>
            <div className="row g-4">
                <div className="col-lg-4 col-md-6 wow fadeInUp p-2" data-wow-delay="0.3s">
                    <div className="team-item">
                        <div className="text-center p-4">
                            <h5 className="mb-1 text-start">Sahibzada Murtaza Ali</h5>
                            <ul style={{textAlign:'left', paddingLeft:"14px"}}>
                            <li className="m-0" style={{fontSize:"12px", fontWeight:"700"}}>Founding Partner</li>
                            <li className="m-0" style={{fontSize:"12px", fontWeight:"700"}}>Admitted to practice in 2014</li>
                            <li className="m-0" style={{fontSize:"12px", fontWeight:"700"}}>Post Graduate Diploma Taxation (P.U.)</li>
                            <li className="m-0" style={{fontSize:"12px", fontWeight:"700"}}>L.L.B P.U</li>
                            <li className="m-0" style={{fontSize:"12px", fontWeight:"700"}}>B.A, P.U</li>
                            <li className="m-0" style={{fontSize:"12px", fontWeight:"700"}}>ACCA (F1- F3)</li>
                            <li className="m-0" style={{fontSize:"12px", fontWeight:"700"}}>Advocate High Court</li>
                            </ul>
                            <Link to="/team#SMurtaza" className="btn btn-primary mt-2">View Profile</Link>                       
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 wow fadeInUp p-2" data-wow-delay="0.3s">
                    <div className="team-item">
                        <div className="text-center p-4">
                            <h5 className="mb-1 text-start">Ghulam Mujtaba Ilyas</h5>
                            <ul style={{textAlign:'left', paddingLeft:"14px"}}>
                            <li className="m-0" style={{fontSize:"12px", fontWeight:"700"}}> Partner</li>
                            <li className="m-0" style={{fontSize:"12px", fontWeight:"700"}}> Admitted to practice in 2010</li>
                            <li className="m-0" style={{fontSize:"12px", fontWeight:"700"}}> LL.M - International Trade and Commercial Law, Durham University</li>
                            <li className="m-0" style={{fontSize:"12px", fontWeight:"700"}}> B.A LL.B (Hons.)</li>
                            <li className="m-0" style={{fontSize:"12px", fontWeight:"700"}}> Diploma in Banking Law</li>
                            <li className="m-0" style={{fontSize:"12px", fontWeight:"700"}}> Advocate High Court</li>
                          </ul>
                            <Link to="/team#GMujtaba" className="btn btn-primary mt-2">View Profile</Link>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 wow fadeInUp p-2" data-wow-delay="0.3s">
                    <div className="team-item">
                        <div className="text-center p-4">
                            <h5 className="mb-1 text-start">Syed Zain Raza Naqvi</h5>
                            <ul style={{textAlign:'left', paddingLeft:"14px", minHeight:"126px"}}>
                            <li className="m-0" style={{fontSize:"12px", fontWeight:"700"}}> Partner</li>
                            <li className="m-0" style={{fontSize:"12px", fontWeight:"700"}}> Admitted to practice in 2015</li>
                            <li className="m-0" style={{fontSize:"12px", fontWeight:"700"}}> LL.M – International Banking & Finance Law, City University London</li>
                            <li className="m-0" style={{fontSize:"12px", fontWeight:"700"}}> LL.B (Hons.), University of London</li>
                            <li className="m-0" style={{fontSize:"12px", fontWeight:"700"}}> Advocate High Court</li>
                          </ul>
                            <Link to="/team#SZain" className="btn btn-primary mt-2">View Profile</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div className="container-fluid pt-6 pb-6">
        <div className="container">
            <div className="text-center mx-auto wow fadeInUp" data-wow-delay="0.1s" style={{maxWidth: "600px"}}>
                <h1 style={{color: "#bb790f"}} className="display-6 text-uppercase mb-5">Our Clients</h1>
            </div>
            <div className="row g-5 align-items-center">
                <div className="col-lg-2 wow fadeInUp" data-wow-delay="0.3s">
                    <img src={testimonial1} style={{maxWidth:"100%", width:"120px"}} />
                </div>
                <div className="col-lg-2 wow fadeInUp" data-wow-delay="0.3s">
                    <img src={testimonial2} style={{maxWidth:"100%", width:"120px"}} />
                </div>
                <div className="col-lg-2 wow fadeInUp" data-wow-delay="0.3s">
                    <img src={testimonial3} style={{maxWidth:"100%", width:"120px"}} />
                </div>
                <div className="col-lg-2 wow fadeInUp" data-wow-delay="0.3s">
                    <img src={testimonial4} style={{maxWidth:"100%", width:"120px"}} />
                </div>
                <div className="col-lg-2 wow fadeInUp" data-wow-delay="0.3s">
                    <img src={testimonial5} style={{maxWidth:"100%", width:"120px"}} />
                </div>
                <div className="col-lg-2 wow fadeInUp" data-wow-delay="0.3s">
                    <img src={testimonial6} style={{maxWidth:"100%", width:"120px"}} />
                </div>
                <div className="col-lg-2 wow fadeInUp" data-wow-delay="0.3s">
                    <img src={testimonial7} style={{maxWidth:"100%", width:"120px"}} />
                </div>
                <div className="col-lg-2 wow fadeInUp" data-wow-delay="0.3s">
                    <img src={testimonial8} style={{maxWidth:"100%", width:"100px"}} />
                </div>
                <div className="col-lg-2 wow fadeInUp" data-wow-delay="0.3s">
                    <img src={testimonial9} style={{maxWidth:"100%", width:"120px"}} />
                </div>
                <div className="col-lg-2 wow fadeInUp" data-wow-delay="0.3s">
                    <img src={testimonial10} style={{maxWidth:"100%", width:"120px"}} />
                </div>
                <div className="col-lg-2 wow fadeInUp" data-wow-delay="0.3s">
                    <img src={testimonial11} style={{maxWidth:"100%", width:"120px"}} />
                </div>
                <div className="col-lg-2 wow fadeInUp" data-wow-delay="0.3s">
                    <img src={testimonial12} style={{maxWidth:"100%", width:"120px"}} />
                </div>

            </div>
        </div>
    </div>
        </>
    )

}


export default Home;